import React from 'react'
import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import OfferPageStickyFooter from './OfferPageStickyFooter'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import { getHotelOfferDisplayedValue } from 'lib/offer/getOfferDisplayPricing'
import { useOfferPackagePrice } from 'hooks/Offers/useOfferPrice'
import { pluralizeToString } from 'lib/string/pluralize'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowLoyaltyPrice from 'components/Luxkit/PricePoints/Loyalty/PriceRowLoyaltyPrice'
import LuxPlusPriceGuard from 'luxPlus/components/LuxPlusPriceGuard'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'

interface Props {
  lowestPricePackage: App.Package | App.BundlePackageWithPrice;
  onScrollTo: () => void;
  offer: App.Offer | App.OfferSummary;
  visible: boolean;
  airport?: App.Airport;
}

function HotelOfferPageStickyFooter(props: Props) {
  const {
    onScrollTo,
    offer,
    visible,
    airport,
  } = props

  const luxPlusEnabled = useAppSelector(isLuxPlusEnabled)
  const isForceBundled = !!offer.bundledWithFlightsOnly
  const flightPrice = offer.flightPrices[airport?.code ?? '']
  const pricePackage = useOfferPackagePrice(props.lowestPricePackage, offer, { flightPrice })
  const shouldShowRate = pricePackage.valueOffPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const shouldShowValue = getHotelOfferDisplayedValue(isForceBundled, pricePackage.totalPrice, pricePackage.totalValue, !!offer.shouldDisplayValue)
  const discountPercentage = luxPlusEnabled ? pricePackage.memberValueOffPercent || pricePackage.valueOffPercent : pricePackage.valueOffPercent

  return (
    <OfferPageStickyFooter visible={visible} callToActionCopy="View options" onCTAClick={onScrollTo}>
      <div>
        <PriceRowPriceCaption>
          {pluralizeToString('night', props.lowestPricePackage.duration)}{isForceBundled ? ' + flights' : ''} from
        </PriceRowPriceCaption>
        <LuxPlusPriceGuard
          showMemberPrice={(pricePackage.totalMemberPrice ?? 0) > 0}
          fallbackPrice={ <PriceRowPrice
            size="M"
            price={isForceBundled ? pricePackage.totalPriceWithFlights : pricePackage.totalPrice}
            saleUnit={isForceBundled ? 'package*' : pricePackage.saleUnit}
          />}
        >
          <PriceRowLoyaltyPrice
            size="M"
            memberPrice={isForceBundled ? pricePackage.totalMemberPriceWithFlights : pricePackage.totalMemberPrice}
            saleUnit={pricePackage.saleUnit}
            logoPlacement="leading"
          />
        </LuxPlusPriceGuard>
        {shouldShowValue && shouldShowRate && <PriceRowValueDiscountWithCaption
          size="L"
          originalValue={Math.ceil(isForceBundled ? pricePackage.totalValueWithFlights : pricePackage.totalValue)}
          discountPercentage={discountPercentage}
        />}
      </div>
    </OfferPageStickyFooter>
  )
}

export default withOfferPageState((state) => {
  return {
    airport: state.airport,
  }
})(HotelOfferPageStickyFooter)
